import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowOrderDashboard } from "../../utils";

function RestrictOrderDashboard(props) {
  if (IsShowOrderDashboard()) return props.children;
  return <NotAccess />;
}

export default RestrictOrderDashboard;
